/**
 * Authentication Context Definition
 * Separated from provider for Fast Refresh compatibility
 */

import { createContext } from 'react'
import { User, LoginFormData, SignupFormData } from '@/types'

export interface AuthContextType {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  login: (credentials: LoginFormData) => Promise<void>
  signup: (data: SignupFormData) => Promise<void>
  logout: () => Promise<void>
  refreshUser: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
